import "./style.scss";


export default function ApiLoader() {
  return (
    // <div class="api_loader"></div>
<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
  )
}
